// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"cf06f9c1","385":"a1ddbf79"}[chunkId] + ".chunk.js";
};